export function getImageUrl(item, size = 200, format = 'webp') {
  const base1 = import.meta.env.VITE_URL_IMG1;
  const base2 = import.meta.env.VITE_URL_IMG2;
  return `${base1}${size}${base2}/${item}@${format}`;
}
